import styled from 'styled-components';

export const AuthBlock = styled.div`
  display: flex;
  justify-content: space-between;
  width: 900px;
  margin: 30px auto;
`;
